import { render, staticRenderFns } from "./frequency_button.vue?vue&type=template&id=26a77940&scoped=true&"
import script from "./frequency_button.vue?vue&type=script&lang=js&"
export * from "./frequency_button.vue?vue&type=script&lang=js&"
import style0 from "./frequency_button.vue?vue&type=style&index=0&id=26a77940&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a77940",
  null
  
)

export default component.exports